import React from "react";
import "./screens.css";

const NotFoundScreen = ({ goToHome }) => {
  return (
    <div className="not-found-container">
      <div className="not-found-icon">
        <img src="/cry_icon.webp" width="100" alt="悲しい顔" />
      </div>
      <h2 className="not-found-title">アプリが見つかりません</h2>
      <p className="not-found-message">削除されたか、URLが間違っています</p>
      <button className="not-found-button" onClick={goToHome}>
        アプつく！へ
      </button>
    </div>
  );
};

export default NotFoundScreen;
